namespace TabAurous.Sales {
    export namespace SalesMasterAPIService {
        export const baseUrl = '~/api/Sales/SalesMasterAPI';

        export declare function Create(request: Serenity.SaveRequest<SalesMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<SalesMasterRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<SalesMasterRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "~/api/Sales/SalesMasterAPI/Create",
            Update = "~/api/Sales/SalesMasterAPI/Update",
            Delete = "~/api/Sales/SalesMasterAPI/Delete",
            Retrieve = "~/api/Sales/SalesMasterAPI/Retrieve",
            List = "~/api/Sales/SalesMasterAPI/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>SalesMasterAPIService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
